import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
var DEFAULT_EXPIRATION = 1000 * 60 * 15; // 15 mins in milliseconds
var Cache = /*#__PURE__*/function () {
  function Cache() {
    var args = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Cache);
    var _args$expiration = args.expiration,
      expiration = _args$expiration === void 0 ? DEFAULT_EXPIRATION : _args$expiration;
    this.map = {};
    this.expiration = expiration;
  }
  _createClass(Cache, [{
    key: "get",
    value: function get(key) {
      var returnExpired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var entry = this.map[key];
      if (entry) {
        if (entry.isExpired()) {
          delete this.map[key];
          return returnExpired ? entry.getResult() : undefined;
        } else {
          return entry.getResult();
        }
      }
      return;
    }
  }, {
    key: "set",
    value: function set(key, result) {
      var entry = new Entry({
        result: result,
        expirationTime: Date.now() + this.expiration,
        accessCount: 0
      });
      this.map[key] = entry;
    }
  }, {
    key: "has",
    value: function has(key) {
      return key in this.map;
    }
  }, {
    key: "clear",
    value: function clear(key) {
      if (key) {
        delete this.map[key];
      } else {
        this.map = {};
      }
    }
  }, {
    key: "serialize",
    value: function () {
      var _serialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var serialized, resolvers;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              serialized = {};
              resolvers = Object.entries(this.map).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  entry = _ref2[1];
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return entry.getResult();
                      case 2:
                        _context.t0 = _context.sent;
                        _context.t1 = entry.getExpirationTime();
                        _context.t2 = entry.getAccessCount();
                        serialized[key] = {
                          result: _context.t0,
                          expirationTime: _context.t1,
                          accessCount: _context.t2
                        };
                      case 6:
                      case "end":
                        return _context.stop();
                    }
                  }, _callee);
                }))();
              });
              _context2.next = 4;
              return Promise.all(resolvers);
            case 4:
              return _context2.abrupt("return", JSON.stringify(serialized));
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function serialize() {
        return _serialize.apply(this, arguments);
      }
      return serialize;
    }()
  }, {
    key: "deserialize",
    value: function deserialize(persisted) {
      try {
        var object = JSON.parse(persisted);
        for (var key in object) {
          var _object$key = object[key],
            result = _object$key.result,
            expirationTime = _object$key.expirationTime,
            accessCount = _object$key.accessCount;
          this.map[key] = new Entry({
            result: Promise.resolve(result),
            expirationTime: expirationTime,
            accessCount: accessCount
          });
        }
      } catch (e) {
        // TODO: Log error via sentry
      }
    }
  }]);
  return Cache;
}();
var Entry = /*#__PURE__*/function () {
  function Entry(_ref4) {
    var result = _ref4.result,
      expirationTime = _ref4.expirationTime,
      accessCount = _ref4.accessCount;
    _classCallCheck(this, Entry);
    this.result = result;
    this.expirationTime = expirationTime;
    this.accessCount = accessCount;
  }
  _createClass(Entry, [{
    key: "getResult",
    value: function getResult() {
      this.accessCount++;
      return this.result;
    }
  }, {
    key: "isExpired",
    value: function isExpired() {
      return this.expirationTime < Date.now();
    }
  }, {
    key: "getExpirationTime",
    value: function getExpirationTime() {
      return this.expirationTime;
    }
  }, {
    key: "getAccessCount",
    value: function getAccessCount() {
      return this.accessCount;
    }
  }]);
  return Entry;
}();
export var getInstance = function getInstance(args) {
  return new Cache(args);
};